import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const HeartIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.0237 19.9348L18.561 13.2528C20.3748 11.3988 20.3748 8.38177 18.561 6.52782C16.8495 4.77849 14.137 4.69358 12.3288 6.26994L12.0003 6.55637L11.6717 6.26994C9.86347 4.69358 7.15097 4.77849 5.4395 6.52782C3.62594 8.3815 3.6256 11.3981 5.44012 13.2534C5.44032 13.2536 5.44051 13.2538 5.4407 13.254L12.0237 19.9348Z"
        stroke={color}
      />
    </svg>
  );
};

export default HeartIcon;
